import {
  UpsellActionButton,
  UpsellAddOnsContainer,
  UpsellAddOnsHeader,
  UpsellAnimatedWrapper,
  UpsellBackdrop,
  UpsellCloseIcon,
  UpsellConfirmationContainer,
  UpsellConfirmationHeader,
  UpsellContainer,
  UpsellFooter,
  UpsellLineItemContainer,
  UpsellLineItemDescription,
  UpsellLineItemHeader,
  UpsellLineItemImage,
  UpsellOptionsContainer,
  UpsellOptionsHeader,
  UpsellScreenContainer,
  UpsellSeeMore,
} from './components';

export const Upsell = {
  ScreenContainer: UpsellScreenContainer,
  Backdrop: UpsellBackdrop,
  Container: UpsellContainer,
  ConfirmationContainer: UpsellConfirmationContainer,
  ConfirmationHeader: UpsellConfirmationHeader,
  LineItemContainer: UpsellLineItemContainer,
  LineItemHeader: UpsellLineItemHeader,
  LineItemImage: UpsellLineItemImage,
  LineItemDescription: UpsellLineItemDescription,
  AddOnsContainer: UpsellAddOnsContainer,
  AddOnsHeader: UpsellAddOnsHeader,
  OptionsContainer: UpsellOptionsContainer,
  OptionsHeader: UpsellOptionsHeader,
  ActionButton: UpsellActionButton,
  CloseIcon: UpsellCloseIcon,
  Footer: UpsellFooter,
  SeeMore: UpsellSeeMore,
  AnimatedWrapper: UpsellAnimatedWrapper,
};

export * from './hooks';
export * from './upsell.constants';
